export default __webpack_public_path__ + "static/media/afternoon.9801dec6.svg";